/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
    <style include="app-styles">
      paper-card {
        height: fit-content !important;
        padding:24px 10% 10%;
      }
      paper-checkbox .selection-checkbox {
        --paper-checkbox-label-spacing: 0;
        --paper-checkbox-checked-color: #3CB371;
      }
      .list-search{
        padding: 0 0px 20px 0px;
      }
      .listing-filter-actions {
        padding: 0px 24px 24px;
      }
      .font-style {
        letter-spacing: 0.0025em;
      }
      .heading-sub-font {
        padding: 0px 24px 24px;
      }
      .font-color{
        color: rgb(0, 131, 155);
      }
      .redirection-text {
        font-size: 16px;
        font-weight: 700;
        color: #101214;
      }
    </style>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <div class="content-align-center">
      <div class="margin-b-zero mdl-cell mdl-cell--10-col">
        <paper-card>
          <div>
            <nbb-success-screen title={{successText}} sub-title-list = {{subTitleList}} enable-button={{enableButton}} hide-reference={{hideReference}}></nbb-success-screen>
          </div>
          <div style="margin:0px 18px 0px 18px;">
            <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px;border:2px solid #f6f8f9;border-radius: 5px;">
              <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;">
                  <div class="mdl-cell mdl-cell--12-col-desktop redirection-text wrapClass1" role="cell">
                      {{getSuccessLabel()}}
                  </div>
              </div>
            </div>
            <div class="listing-table-container margin-b-16" style="border:2px solid #f6f8f9;border-radius: 5px;">
              <div class="mdl-cell mdl-cell--12-col margin-32">
                <h1 class="pay_from ft-subtitle padding-b-16"><oe-i18n-msg msgid="b_transfersummary"></oe-i18n-msg></h1>                  
                <div class="mdl-cell mdl-cell--12-col horizontal layout layoutdiv margin-l-zero" style="flex-wrap: wrap">
                  <template is="dom-if" if="{{successResponse.accountIdList.0.accountId}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_dbtAcntNumber"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.accountIdList.0.accountId}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.accountIdList.0.accountName}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_AccountName"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.accountIdList.0.accountName}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.accountIdList.0.accountCurrency.codeDescription}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_accountCurrency"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.accountIdList.0.accountCurrency.codeDescription}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.accountIdList.0.accountType.codeDescription}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_Accounttype"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.accountIdList.0.accountType.codeDescription}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.paymentConsent.reference}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_ReferenceId"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.paymentConsent.reference}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.paymentConsent.codeDescription}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_TransferType"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.paymentConsent.paymentType.codeDescription}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.paymentConsent.creditorAccountId}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_BeneficiaryAcct"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{successResponse.paymentConsent.creditorAccountId}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.paymentConsent.name}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="title-text">
                            <oe-i18n-msg msgid="l_Benefname"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{successResponse.paymentConsent.name}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.paymentConsent.instructedAmount.amount}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_TransferAmt"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.paymentConsent.instructedAmount.currency}} {{successResponse.paymentConsent.instructedAmount.amount}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.paymentConsent.swiftCode}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_swiftCode"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.paymentConsent.swiftCode}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.paymentConsent.purposeCode}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_purposeCode"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{successResponse.paymentConsent.purposeCode.codeDescription}}
                        </div>
                    </div>
                  </template>
                  <template is="dom-if" if="{{successResponse.executionDate}}">
                    <div class="mdl-cell mdl-cell--6-col padding-b-16">
                        <span class="secondary-dark-text-s">
                            <oe-i18n-msg msgid="l_executionDate"></oe-i18n-msg>
                        </span>
                        <div class="primary-dark-text-m font-medium wordbreak-all">
                        {{formatDate(successResponse.executionDate)}}
                        </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </paper-card>
      </div>
    </div>
    `;
Polymer({
  is: 'open-banking-payment-consents-success',
  _template: template,
  behaviors: [corpBehaviours.appCommonBehaviour, corpBehaviours.appMenuBehaviour, corpSbBehaviour.corpAuthAndWorkflow, sbBehaviours.paginationBehaviours],
  properties: {
    selectedPage: {
      type: String,
      notify: true
    },
    userId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    consentId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingConsentId');
      }
    },
    successResponse: {
      type: Array,
      notify: true
    },
    previewDetailsList: {
      type: Array,
      value: []
    },
    openBankingAccountsResponse: {
      type: Array,
      notify: true
    },
    successText: {
      type: String,
      notify: true,
      value: getLabel("l_accountCertificateDocumentRequest")
    },
    enableButton: {
      type: Boolean,
      value: false,
      notify: true
    },
    successObj: {
      type: Object,
      notify: true,
      observer: 'setSuccessMsg'
    },
    hideReference: {
      type: Boolean,
      value: true
    },
    subTitleList: {
      type: Array,
      value: [],
      notify: true
    },
    actionType: {
      type: String,
      notify: true,
      observer: "actionTypeChange"
    },
    showAccountsList: {
      type: Boolean,
      value: true
    }
  },
  setSuccessMsg: function () {
    var self = this;
    if (this.successObj != undefined && Object.keys(this.successObj).length != 0) {
      var message = this.successObj.chennelContext.status.message;
      if (message && message.length) {
        this.subTitleList = message.map(item => {
          return item.messageDesc;
        });
      }
    }
    setTimeout(() => {
      window.location.href = self.successResponse.redirectionUrl;
    }, 5000);
  },
  actionTypeChange() {
    if (this.actionType && this.actionType == "APPROVE") {
      this.showAccountsList = true;
    }
    else {
      this.showAccountsList = false;
    }
  },
  getSuccessLabel() {
    return getLabel("l_openBankingRedirectionText");
  },
  _errorHandler(event) {
    showAjaxError(event);
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        window.location.href = clientStorage.get(storageType.session, 'backendRedirectUri');
      }
    }, 3000);
  }
});
